module.exports = __webpack_public_path__ + "img/next-loot-2.2af115fe.png";